<template lang="pug">
  #order-history
    b-card(header-tag="header")
      order-history-data(:sales_channel="sales_channel")
</template>

<script>
import OrderHistoryData from "@/components/supportSite/OrderHistoryData";

export default {
  name: "OrderHistory",
  components: {
    OrderHistoryData
  },
  props: {
    sales_channel: {type: String, required: false}
  }
}
</script>
